<template>
  <d2-container>
    <el-button
      class="filter-item"
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      v-permission:function="['GrowthCoin:btn_add']"
      @click="getAdd"
    >添加</el-button>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style=" margin-top: 20px"
      :data="cardData"
    >
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="名称">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="图标">
        <template slot-scope="scope">
          <img :src="scope.row.icon" alt style="width:80px;height:80px" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="成长币数量">
        <template slot-scope="scope">
          <span>{{ scope.row.creditCount }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="金额">
        <template slot-scope="scope">
          <span>{{ scope.row.price }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="首充优惠">
        <template slot-scope="scope">
          <span>{{ scope.row.firstCharge == 0 ? '关闭' : '开启' }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="首充数量">
        <template slot-scope="scope">
          <span>{{ scope.row.firstCreditCount }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="排序">
        <template slot-scope="scope">
          <span>{{ scope.row.sort }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="250">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            @click="editGC(scope.row.id)"
            style="margin-top: 10px;"
            v-permission:function="['GrowthCoin:btn_edit']"
          >编辑</el-button>
          <el-button
            size="small"
            type="danger"
            @click="delGC(scope.row.id)"
            style="margin-top: 10px;"
            v-permission:function="['GrowthCoin:btn_del']"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <template slot="footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.currentPage"
        :page-sizes="[10,20,30, 50]"
        :page-size="listQuery.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="width:500px"
      ></el-pagination>
    </template>
  </d2-container>
</template>
<script>
import { mapGetters } from 'vuex'
import {
  getGrowthCoinList,
  delGrowthCoin
} from '@/api/demo/GrowthCoin/index'
export default {
  name: 'GrowthCoin',
  computed: {
    ...mapGetters(['elements'])
  },
  data () {
    return {
      GrowthCoin_btn_add: false,
      GrowthCoin_btn_edit: false,
      GrowthCoin_btn_del: false,

      tableKey: 0,
      listQuery: {
        currentPage: 1,
        pageSize: 20
      },
      cardData: [], // 表格数据
      total: null
    }
  },
  watch: {
    $route (to, from) {
      this.getSearch()
    }
  },
  created () {
    this.getSearch()
  },
  mounted () {},
  methods: {
    // 搜索条件
    getSearch (val) {
      if (val) {
        this.listQuery.currentPage = val
      } else {
        this.listQuery.currentPage = 1
      }
      getGrowthCoinList(this.listQuery).then(res => {
        this.listLoading = true
        this.cardData = res.records
        this.total = parseInt(res.total)
        this.listLoading = false
      })
    },
    // 添加
    getAdd () {
      this.$router.push({
        path: '/demo/GrowthCoin/addGrowthCoin'
      })
    },
    // 编辑
    editGC (id) {
      this.$router.push({
        path: '/demo/GrowthCoin/addGrowthCoin?id=' + id
      })
    },
    // 删除
    delGC (id) {
      delGrowthCoin(id).then(res => {
        this.$notify({
          title: '成功',
          message: '删除成功',
          type: 'success'
        })
        this.getSearch()
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getSearch()
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getSearch(val)
    }
  }
}
</script>

<style scoped>
</style>
